{
  "achievements": "अचीवमेंट्स",
  "advanced": "उन्नत",
  "all": "सभी",
  "antiFakeProtection": "धोखाधड़ी-रोधी सुरक्षा",
  "antiFakeProtectionText": "धोखाधड़ी गतिविधि रोकने के लिए सभी दावे सर्वर-साइड सत्यापित होते हैं।",
  "approvedClaims": "स्वीकृत दावे",
  "approvedExalt": "स्वीकृत EXALT",
  "beginner": "शुरुआती",
  "claim5Exalt": "5 EXALT क्लेम करें",
  "claimDailyMining": "दैनिक माइनिंग इनाम का दावा करें",
  "claimDailyRewardDesc": "अपना दैनिक 5 EXALT इनाम प्राप्त करें।",
  "claimDailyRewardDescription": "प्रतिदिन 5 EXALT प्राप्त करें।",
  "claimFailed": "दावा विफल रहा।",
  "claimedToday": "आज क्लेम हो चुका",
  "completed": "Completed",
  "completedTasks": "पूरा किए गए लेसन",
  "cooldown": "कूलडाउन",
  "correctAnswerRewardAdded": "सही उत्तर! रिवॉर्ड जोड़ दिया गया।",
  "cryptoBasics": "क्रिप्टो बेसिक्स",
  "dailyMiningRate": "दैनिक माइनिंग दर",
  "dailyReward": "डेली रिवॉर्ड",
  "dailyRewardClaimed": "दैनिक इनाम प्राप्त किया गया।",
  "dailyStreak": "डेली स्ट्रीक",
  "days": "दिन",
  "distributed": "वितरित",
  "downloadCertificate": "सर्टिफिकेट डाउनलोड करें",
  "duration": "समय",
  "exaltExchangeUser": "Exalt Exchange उपयोगकर्ता",
  "exaltMiningPool": "EXALT माइनिंग पूल",
  "failedLoadRewards": "इनाम लोड करने में विफल।",
  "firstLesson": "पहला पाठ",
  "intermediate": "मध्यम",
  "learnEarn": "सीखें और कमाएं",
  "learnEarnSubtitle": "वीडियो देखें, क्विज़ पूरा करें और EXALT रिवॉर्ड कमाएँ।",
  "learnEarnTitle": "सीखें और कमाएं",
  "learnerAchievement": "शिक्षार्थी उपलब्धि",
  "learningLevel": "लर्निंग लेवल",
  "learningProgress": "लर्निंग प्रोग्रेस",
  "lessonCompleted": "पाठ सफलतापूर्वक पूरा हुआ।",
  "level": "लेवल",
  "loadingLessons": "पाठ लोड हो रहे हैं...",
  "locked": "Locked",
  "masterAchievement": "मास्टर उपलब्धि",
  "miningProtectionNote": "माइनिंग इनाम स्वचालित और डुप्लिकेट दावों से सुरक्षित हैं।",
  "miningRewardSubmitted": "माइनिंग इनाम का दावा सबमिट किया गया।",
  "myRewardClaims": "मेरे इनाम दावे",
  "noAchievements": "अभी कोई अचीवमेंट नहीं",
  "noActivityYet": "अभी कोई गतिविधि नहीं",
  "noMinersYet": "अभी तक कोई माइनर नहीं।",
  "noReferrersYet": "अभी तक कोई रेफरर नहीं।",
  "noRewardClaimsYet": "अभी तक कोई इनाम दावा नहीं।",
  "oneClaimEvery24Hours": "हर 24 घंटे में एक दावे की अनुमति है।",
  "optionAfterPayment": "भुगतान की पुष्टि के बाद",
  "optionAnyTime": "कभी भी",
  "optionBeforePayment": "भुगतान से पहले",
  "optionDeleteTokens": "टोकन हटाना",
  "optionLockTokens": "रिवॉर्ड के लिए टोकन लॉक करना",
  "optionPrivateKey": "प्राइवेट की शेयर करें",
  "optionProtectWallet": "वॉलेट की सुरक्षित रखें",
  "optionSendTokens": "टोकन भेज देना",
  "optionUnknownLinks": "अनजान लिंक इस्तेमाल करें",
  "p2pSafety": "P2P सुरक्षा",
  "pendingValue": "लंबित मूल्य",
  "questionCrypto": "क्रिप्टो में सबसे सुरक्षित नियम क्या है?",
  "questionP2p": "P2P में क्रिप्टो कब जारी करनी चाहिए?",
  "questionStaking": "स्टेकिंग का क्या मतलब है?",
  "quiz": "क्विज़",
  "recentActivity": "हाल की गतिविधि",
  "referralRewardNote": "रेफरल इनाम व्यवस्थापक सत्यापन के बाद जमा किए जाते हैं।",
  "referralRewardPool": "रेफरल इनाम पूल",
  "referrals": "रेफरल",
  "reward": "Reward",
  "rewardClaim": "इनाम दावा",
  "rewardClaimFailed": "रिवॉर्ड क्लेम विफल रहा।",
  "rewardClaimed": "रिवॉर्ड सफलतापूर्वक क्लेम हुआ।",
  "rewardCompleted": "इनाम पूरा हुआ।",
  "rewardFailed": "इनाम का दावा विफल रहा।",
  "searchLessons": "लेसन खोजें...",
  "securityReview": "सुरक्षा समीक्षा",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "stakingGuide": "स्टेकिंग गाइड",
  "startLesson": "लेसन शुरू करें",
  "submitQuizClaimReward": "क्विज़ सबमिट करें और रिवॉर्ड लें",
  "submitting": "Submitting...",
  "todayClaims": "आज के दावे",
  "topLearners": "टॉप लर्नर्स",
  "topMiners": "शीर्ष माइनर",
  "topReferrers": "शीर्ष रेफरर",
  "totalClaims": "कुल दावे",
  "totalPool": "कुल पूल",
  "totalRewards": "कुल रिवॉर्ड",
  "used": "उपयोग किया गया",
  "videoCryptoBasics": "क्रिप्टो क्या है और एक्सचेंज कैसे काम करते हैं?",
  "videoP2pSafety": "P2P उपयोगकर्ताओं के साथ सुरक्षित रूप से व्यापार कैसे करें",
  "videoStakingGuide": "स्टेकिंग रिवॉर्ड कैसे काम करते हैं",
  "viewAgain": "फिर देखें",
  "wrongAnswerTryAgain": "गलत उत्तर, फिर प्रयास करें।",
  "xpPoints": "XP पॉइंट्स",
  "you": "आप"
}